import * as React from 'react';

const SocialNetworkLinkLogo: React.SFC<{
  Icon: React.SFC<{ hovered?: boolean }>;
  href: string;
}> = ({ Icon, href }) => {
  const [hovered, onHover] = React.useState(false);

  return (
    <a
      href={href}
      target="_blank"
      className="item footer__soc-link"
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
      rel="noreferrer"
    >
      {<Icon hovered={hovered} />}
    </a>
  );
};

export default SocialNetworkLinkLogo;
